const DEFAULT_ERROR = 'Houve um erro e não foi possível completar a operação'

export const formatError = (error, message = DEFAULT_ERROR) => ({
  error: true,
  status: error?.response?.status,
  message,
  errors: error.response?.data?.errors,
})
